import React from 'react'
import { useSelector } from 'react-redux'
import { DataGrid } from '@mui/x-data-grid'
import { useTheme } from '../../../../components/mui/Styles/index'
import { parentFeatureConstants } from '../../../../constants/parent-feature-constants'

export function SerialNumbersTable() {
  const theme = useTheme()
  const parentFeature = useSelector((state) => state.serialNumbers.parentFeature)
  const serialNumbers = useSelector((state) => state.serialNumbers.serialNumbers)
  const selectedOrderItem = useSelector((state) => state.serialNumbers.selectedOrderItem)
  const orderItemSerialNumbers = selectedOrderItem?.serialNumbers
  const itemTagSerialNumbers =
    parentFeature === parentFeatureConstants.ORDERS ? orderItemSerialNumbers : serialNumbers

  const rows = itemTagSerialNumbers?.map((item) => ({
    id: item,
    serialNumber: item,
  }))

  const columns = [{ field: 'serialNumber', headerName: 'Serial #', flex: 1, minWidth: 150 }]

  const gridStyle = {
    minHeight: '150px',
    backgroundColor: theme.palette.common.white,
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: theme.palette.grey[300],
  }

  return (
    <DataGrid
      sx={gridStyle}
      rows={rows}
      columns={columns}
      initialState={{
        pagination: {
          paginationModel: { pageSize: 25, page: 0 },
        },
      }}
      pageSizeOptions={[25, 50]}
      spacing={1}
      slotProps={{
        pagination: {
          component: 'div',
          showLastButton: true,
          showFirstButton: true,
        },
      }}
      disableRowSelectionOnClick
    />
  )
}

export default SerialNumbersTable
